import { useEffect } from "react";
import { useRecoilState } from "recoil";

import { fireService } from "../../services/fire";
import { useFlowNavigation } from "../useFlowNavigation";

import { PageNames } from "@enums";
import { businessRulesState } from "@states";
import { BusinessRulesInterface } from "@types";

export function useBusinessRules() {
    const isSSR = typeof global.window === "undefined";
    const [businessRules, setBusinessRules] =
        useRecoilState(businessRulesState);
    const { navigateTo } = useFlowNavigation();

    useEffect(() => {
        if (!isSSR && !businessRules) {
            fireService
                .getBusinessRules()
                .then((response) => {
                    const rules = response as unknown as BusinessRulesInterface;
                    setBusinessRules(rules);
                })
                .catch((error) => {
                    console.error(error);
                    navigateTo(PageNames.TechnicalDifficulties);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR, setBusinessRules]);

    return businessRules;
}
